export * from './lazy-tab.directive';
export * from './tab-group/tab-group.component';
export * from './tab.module';
export * from './tab/tab.component';
